import { readStates, saveStates } from '@/constants/lifecycle';
import pagingWithFilteredResults from '@/constants/states';
import { collectionPermissionGroupNames, collectionPermissions } from '../constants';

export const collectionPerms = (can = false) => {
  const permissions = {};
  Object.values(collectionPermissions).forEach((permission) => {
    permissions[permission] = can;
  });
  return permissions;
};

export const collectionPermsFromArray = (truePermissions = []) => {
  const permissions = collectionPerms();

  truePermissions.forEach((permission) => {
    permissions[permission] = true;
  });

  return permissions;
};

export const newCollectionMember = (member, permissions) => (
  {
    ...member,
    permissions: { ...permissions },
    selected: false,
  }
);

export const collectionMembers = (pageSize = 20, minFilterLength = 0, requiresFilter = false) => (
  {
    ...pagingWithFilteredResults(pageSize, minFilterLength, requiresFilter),
    original: [],
    ...readStates,
  }
);

const sharingCollection = () => ({
  open: false,
  code: '',
  category: '',
  permissionGroup: collectionPermissionGroupNames.DATASETS,
  membersToAdd: [],
  ...saveStates,
});

export default sharingCollection;
